import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IVehicleType from '../interfaces/IVehicleType';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IVehicleType>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'vehicle-type'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Vehicle type successfully created!'}  
        title={'Add vehicle type'}  
        subheader={'Add vehicle type'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
